//
//
//
//
//
//
//
//

import Sizeable from "../../mixins/Sizeable";
import Alignable from "../../mixins/Alignable";

export default {
    name: "CardText",

    mixins: [Sizeable, Alignable],

    props: {
        // Whether to stretch the content over the full available height of the parent
        fill: {
            type: Boolean,
            default: false
        }
    }
}
